/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * StavertonAPI
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import type {
  AdminListQueriesParams,
  AdminQueryListResponse,
  QueryUpdateClaimedRequest,
  QueryUpdateClaimedResponse,
  QueryUpdateResolvedRequest,
  QueryUpdateResolvedResponse
} from './index.schemas';

import { useCustomInstance } from '../staverton.openapi.axios';





export const useAdminListQueriesHook = () => {
        const adminListQueries = useCustomInstance<AdminQueryListResponse>();

        return useCallback((
    params?: AdminListQueriesParams,
 signal?: AbortSignal
) => {
        return adminListQueries(
          {url: `/AdminQuery/List`, method: 'GET',
        params, signal
    },
          );
        }, [adminListQueries])
      }
    

export const getAdminListQueriesQueryKey = (params?: AdminListQueriesParams,) => {
    return [`/AdminQuery/List`, ...(params ? [params]: [])] as const;
    }

    
export const useAdminListQueriesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useAdminListQueriesHook>>>, TError = unknown>(params?: AdminListQueriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminListQueriesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminListQueriesQueryKey(params);

  const adminListQueries =  useAdminListQueriesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminListQueriesHook>>>> = ({ signal }) => adminListQueries(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminListQueriesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminListQueriesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminListQueriesHook>>>>
export type AdminListQueriesQueryError = unknown


export function useAdminListQueries<TData = Awaited<ReturnType<ReturnType<typeof useAdminListQueriesHook>>>, TError = unknown>(
 params: undefined |  AdminListQueriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminListQueriesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminListQueriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminListQueriesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListQueries<TData = Awaited<ReturnType<ReturnType<typeof useAdminListQueriesHook>>>, TError = unknown>(
 params?: AdminListQueriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminListQueriesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminListQueriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminListQueriesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminListQueries<TData = Awaited<ReturnType<ReturnType<typeof useAdminListQueriesHook>>>, TError = unknown>(
 params?: AdminListQueriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminListQueriesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminListQueries<TData = Awaited<ReturnType<ReturnType<typeof useAdminListQueriesHook>>>, TError = unknown>(
 params?: AdminListQueriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminListQueriesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useAdminListQueriesQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const useAdminUpdateQueryClaimedHook = () => {
        const adminUpdateQueryClaimed = useCustomInstance<QueryUpdateClaimedResponse>();

        return useCallback((
    queryUpdateClaimedRequest: QueryUpdateClaimedRequest,
 ) => {
        return adminUpdateQueryClaimed(
          {url: `/AdminQuery/UpdateClaimed`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: queryUpdateClaimedRequest
    },
          );
        }, [adminUpdateQueryClaimed])
      }
    


export const useAdminUpdateQueryClaimedMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAdminUpdateQueryClaimedHook>>>, TError,{data: QueryUpdateClaimedRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAdminUpdateQueryClaimedHook>>>, TError,{data: QueryUpdateClaimedRequest}, TContext> => {

const mutationKey = ['adminUpdateQueryClaimed'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const adminUpdateQueryClaimed =  useAdminUpdateQueryClaimedHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAdminUpdateQueryClaimedHook>>>, {data: QueryUpdateClaimedRequest}> = (props) => {
          const {data} = props ?? {};

          return  adminUpdateQueryClaimed(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateQueryClaimedMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminUpdateQueryClaimedHook>>>>
    export type AdminUpdateQueryClaimedMutationBody = QueryUpdateClaimedRequest
    export type AdminUpdateQueryClaimedMutationError = unknown

    export const useAdminUpdateQueryClaimed = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAdminUpdateQueryClaimedHook>>>, TError,{data: QueryUpdateClaimedRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useAdminUpdateQueryClaimedHook>>>,
        TError,
        {data: QueryUpdateClaimedRequest},
        TContext
      > => {

      const mutationOptions = useAdminUpdateQueryClaimedMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const useAdminUpdateQueryResolvedHook = () => {
        const adminUpdateQueryResolved = useCustomInstance<QueryUpdateResolvedResponse>();

        return useCallback((
    queryUpdateResolvedRequest: QueryUpdateResolvedRequest,
 ) => {
        return adminUpdateQueryResolved(
          {url: `/AdminQuery/UpdateResolved`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: queryUpdateResolvedRequest
    },
          );
        }, [adminUpdateQueryResolved])
      }
    


export const useAdminUpdateQueryResolvedMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAdminUpdateQueryResolvedHook>>>, TError,{data: QueryUpdateResolvedRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAdminUpdateQueryResolvedHook>>>, TError,{data: QueryUpdateResolvedRequest}, TContext> => {

const mutationKey = ['adminUpdateQueryResolved'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const adminUpdateQueryResolved =  useAdminUpdateQueryResolvedHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAdminUpdateQueryResolvedHook>>>, {data: QueryUpdateResolvedRequest}> = (props) => {
          const {data} = props ?? {};

          return  adminUpdateQueryResolved(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminUpdateQueryResolvedMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminUpdateQueryResolvedHook>>>>
    export type AdminUpdateQueryResolvedMutationBody = QueryUpdateResolvedRequest
    export type AdminUpdateQueryResolvedMutationError = unknown

    export const useAdminUpdateQueryResolved = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAdminUpdateQueryResolvedHook>>>, TError,{data: QueryUpdateResolvedRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useAdminUpdateQueryResolvedHook>>>,
        TError,
        {data: QueryUpdateResolvedRequest},
        TContext
      > => {

      const mutationOptions = useAdminUpdateQueryResolvedMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    